import * as moment from "moment";
import {Link} from "react-router-dom";

declare global {
    interface Window {
        // Google analytics data layer
        LvDataLayer: any;
    }
}

export class PluginTemplates {

    public static convertDate = (inputDate: string, format: string) => {
        const valueAsMoment = moment(inputDate, moment.ISO_8601);
        if (valueAsMoment.isValid()) {
            return (valueAsMoment.format(format))
        }
        return null;
    };

    public static getOrdinal = (num: number): string => {
        const suffixes = ["th","st","nd","rd"];
        const numberEnding = num % 100;
        return num + (suffixes[(numberEnding - 20) % 10] || suffixes[numberEnding] || suffixes[0]);
    };

    public static convertWolfPaymentDate = (date: string): string => {
        const nextPaymentDate = moment().set("date", parseInt(date, 10));
        return PluginTemplates.getOrdinal(parseInt(moment(nextPaymentDate).format("DD"), 10))
    }

    public static convertDateUTC = (inputDate: string, format: string) => {
        const valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
        if (valueAsMoment.isValid()) {
            return (valueAsMoment.format(format))
        }
        return null;
    };

    public renderBackButton = (link?: string) =>
            link ?
                <Link to={link} className="no-underline">
                    <button type="button" className="btn btn-back plugin">Back</button>
                </Link> :
                <a onClick={this.goBack} className="no-underline">
                    <button type="button" className="btn btn-back plugin">Back</button>
                </a>;

    public renderBackLink(buttonName: string, isTop: boolean, link?: string) {
        if (link) {
            return (
                <div className={`${isTop ? "back-link-top" : "back-link-bottom"}`}>
                    <Link to={link}>
                        <button type="button" role="link" className={`btn btn-back-link`}>{buttonName}</button>
                    </Link>
                </div>
            )
        }

        return (
            <div className={`${isTop ? "back-link-top" : "back-link-bottom"}`}>
                <a onClick={this.goBack}>
                    <button type="button" role="link" className={`btn btn-back-link`}>{buttonName}</button>
                </a>
            </div>
        )
    }

    public renderBackReloadLink(buttonName: string, isTop: boolean, link: string) {
        return (
            <div className={`${isTop ? "back-link-top" : "back-link-bottom"}`}>
                <button type="button" className={`btn btn-back-link`} onClick={this.navigateTo(link)}>{buttonName}</button>
            </div>
        )
    }

    public renderBackReloadLinkWithAdditionalFunctionality(buttonName: string, isTop: boolean, link: string, additionalFunctionality: any) {
        return (
            <div className={`${isTop ? "back-link-top" : "back-link-bottom"}`}>
                <button type="button" className={`btn btn-back-link`} onClick={additionalFunctionality}>{buttonName}</button>
            </div>
        )
    }

    public setPageTitle = (pageTitle: string) => {
        document.title = pageTitle;

        window.LvDataLayer = {
            pageTitle
        }
    };

    private goBack(event: any) {
        event.target.href = window.history.back();
    }

    private navigateTo(link: string){
        return () => {
            window.location.href = link;
        }
    }
}
